module.exports = __webpack_public_path__ + "fonts/TTNormsPro-ExtraLightItalic.c89601fd.ttf";